<template>
  <div class="pa-10">
    <OJTInstructorDataTable />
  </div>
</template>

<script>
import OJTInstructorDataTable from "@/components/Utils/OJTInstructorDataTable.vue";

export default {
  components: {
    OJTInstructorDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {
    // shouldShow() {
    //   let allowed = [2, 3];
    //   return allowed.includes($store.state.user.usertype.id);
    // },
  },
};
</script>

<style></style>
